/**
* ------------------------------------------------------------------------
* Libraries for packaging CXP items
* ------------------------------------------------------------------------
*/

import packageItems from './lib/package';
import packageCxpStatics, { packageCxpStaticsDir } from './lib/package-cxp-statics';
import extractProvisionPackage from './lib/extract-package';

/**
 * Packaging methods for creating provisioned packages for CXP
 *
 * @module @bb-cli/lib-package
 * @type {object}
 * @example
 * Basic Example
 *
 * ```javascript
 * import { packageCxpStatics, packageCxpStaticsDir } from '@bb-cli/bb-package';
 * ```
 */

export {
  packageCxpStatics,
  packageCxpStaticsDir,
  extractProvisionPackage,
  packageItems,
};
